export const ClientTicketStatus = {
  ACCEPTED: {
    key: 'ACCEPTED',
    label: '정상',
  },
  CANCELED: {
    key: 'CANCELED',
    label: '취소',
  },
  EXPIRED: {
    key: 'EXPIRED',
    label: '만료',
  },
} as const;

export const VendorTicketStatus = {
  ACCEPTED: {
    key: 'ACCEPTED',
    label: '정상',
  },
  CANCELED: {
    key: 'CANCELED',
    label: '취소',
  },
  EXPIRED: {
    key: 'EXPIRED',
    label: '만료',
  },
} as const;

export type ClientTicketStatus = keyof typeof ClientTicketStatus;
export type VendorTicketStatus = keyof typeof VendorTicketStatus;
